/* ======================================================================
   BLOQUE «¿CÓMO QUIERES COMPRAR?» DEL PANEL DEL CARRITO
   ======================================================================
   Entre los productos y «Finalizar Compra Segura» ofrece dos formas de
   pagar: compra única o con membresía. Todo se calcula con el carrito
   real, nunca con cifras escritas a mano.

   POR QUÉ ES JAVASCRIPT Y NO LIQUID
   El panel del carrito no es el del theme: lo pinta la app UpCart. El
   <cart-drawer> del theme existe pero está oculto y sin usar. Así que no
   hay Liquid donde meter esto; la app sí expone una API con sus propios
   eventos, y es de lo que se cuelga este archivo.

   ENCENDER Y APAGAR
   El bloque vive siempre en el theme pero nace oculto. Se enciende, por
   orden de prioridad:

     1. ?membresia=1 en la URL          → para probar sin tocar nada
     2. window.CART_MEMBRESIA_ACTIVO    → para que lo fuerce Convert
     3. El ajuste del tema              → Configuración del tema → Carrito

   Con ?membresia=0 se apaga aunque el ajuste esté encendido.

   A QUIÉN NO SE LE MUESTRA
   A los miembros con sesión iniciada. Eso se sabe por el tag
   `miembroactivo`, que solo se puede leer desde el servidor, así que
   layout/theme.liquid publica `window.esMiembroActivo`. Si esa variable
   no existe, el bloque no se muestra a nadie con sesión iniciada: más
   vale perder audiencia que ofrecerle una membresía a quien ya la tiene.

   LA TASA DE DESCUENTO
   El descuento de miembro lo aplica una app en el carrito, no el theme,
   y no publica su regla en ningún sitio legible. Así que:

     · cuando la membresía está en el carrito, todas las cifras salen del
       carrito y son exactas;
     · de paso se mide la tasa real y se guarda, para poder estimar el
       precio antes de que el comprador elija;
     · hasta que se mide una vez, se usa la tasa del ajuste del tema.
   ====================================================================== */

(function () {
  'use strict';

  var ID = 'cmb-bloque';
  var CLAVE_TASA = 'cmb_tasa_descuento';

  var cfg = window.CART_MEMBRESIA_CONFIG || {};
  var VARIANTE = parseInt(cfg.varianteId, 10) || 42111080792273;
  var PLAN = parseInt(cfg.planId, 10) || 1156088017;
  var CUOTA_ANUAL = (parseInt(cfg.cuotaAnual, 10) || 99000) * 100;   // en céntimos
  var TASA_POR_DEFECTO = parseFloat(cfg.tasaDescuento) || 10.1;      // %

  var TEXTOS = {
    titulo: cfg.titulo || '¿Cómo quieres comprar?',
    unica: cfg.unica || 'Compra única',
    unicaNota: cfg.unicaNota || 'Solo este pedido',
    conMembresia: cfg.conMembresia || 'Con membresía',
    ahorroAnual: cfg.ahorroAnual || 'Un miembro ahorra hasta $1.000.000 al año',
    envio: cfg.envio || 'Envío gratis en compras desde $200.000'
  };

  /* ---------- Encendido ---------- */

  function estaEncendido() {
    var url = new URLSearchParams(window.location.search).get('membresia');
    if (url === '1') return true;
    if (url === '0') return false;
    return window.CART_MEMBRESIA_ACTIVO === true;
  }

  function esMiembro() {
    // Sin el dato del servidor no se arriesga: se oculta a quien tenga sesión.
    if (typeof window.esMiembroActivo === 'boolean') return window.esMiembroActivo;
    var c = window.upcart && window.upcart.customer;
    return !!(c && c.isLoggedIn);
  }

  /* ---------- Dinero ---------- */

  // Se usa el formateador de la app para que las cifras salgan igual que las
  // del resto del panel. Recibe un objeto, no un número: upcartFormatMoney(123)
  // devuelve «$0» sin avisar.
  function money(centimos) {
    if (typeof window.upcartFormatMoney === 'function') {
      try {
        var r = window.upcartFormatMoney({ cents: centimos, shouldRemoveHTML: true });
        if (r) return r;
      } catch (e) {}
    }
    var pesos = Math.round(centimos / 100);
    return '$' + String(pesos).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function tasaGuardada() {
    try {
      var v = parseFloat(window.localStorage.getItem(CLAVE_TASA));
      if (!isNaN(v) && v > 0 && v < 90) return v;
    } catch (e) {}
    return TASA_POR_DEFECTO;
  }

  function guardarTasa(v) {
    if (!(v > 0 && v < 90)) return;
    try { window.localStorage.setItem(CLAVE_TASA, String(v)); } catch (e) {}
  }

  /* ---------- Lectura del carrito ---------- */

  function leerCarrito() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Separa la membresía del resto y saca las cifras que el bloque necesita.
  function analizar(carrito) {
    var lineaMembresia = null;
    var brutoProductos = 0;   // lo que costarían los productos sin descuento
    var netoProductos = 0;    // lo que cuestan ahora mismo
    var unidades = 0;

    (carrito.items || []).forEach(function (item) {
      if (item.variant_id === VARIANTE) { lineaMembresia = item; return; }
      brutoProductos += item.original_line_price;
      netoProductos += item.final_line_price;
      unidades += item.quantity;
    });

    var conMembresia = !!lineaMembresia;
    var ahorro = brutoProductos - netoProductos;

    // Con la membresía puesta, las cifras son exactas y de paso se aprende
    // la tasa real para poder estimar la próxima vez.
    if (conMembresia && brutoProductos > 0 && ahorro > 0) {
      guardarTasa((ahorro / brutoProductos) * 100);
    }

    // El precio de la compra única es lo que se paga sin el descuento de
    // miembro. Sin la membresía puesta eso es el precio actual del carrito
    // (que puede traer otros descuentos, y esos se respetan); con la
    // membresía puesta hay que volver al precio de lista.
    var precioUnica = conMembresia ? brutoProductos : netoProductos;
    var tasa = tasaGuardada() / 100;
    var precioMiembro = conMembresia ? netoProductos : Math.round(precioUnica * (1 - tasa));

    return {
      hayProductos: unidades > 0,
      conMembresia: conMembresia,
      lineaMembresia: lineaMembresia,
      precioUnica: precioUnica,
      precioConMembresia: precioMiembro,
      ahorroPedido: precioUnica - precioMiembro,
      // Con la membresía en el carrito no se estima nada: son las cifras del carrito.
      cifrasExactas: conMembresia
    };
  }

  /* ---------- Marcado ---------- */

  var ICONO_CHECK = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><circle cx="7" cy="7" r="6.25" stroke="#142688" stroke-width="1.5"/><path d="M4.2 7.2 6.1 9.1 9.8 5.2" stroke="#142688" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICONO_CAMION = '<svg width="16" height="14" viewBox="0 0 16 14" fill="none" aria-hidden="true"><path d="M1 3h8v7H1V3Zm8 2h3l2 2.5V10H9V5Z" stroke="#142688" stroke-width="1.3" stroke-linejoin="round"/><circle cx="4" cy="11.5" r="1.4" stroke="#142688" stroke-width="1.3"/><circle cx="11.5" cy="11.5" r="1.4" stroke="#142688" stroke-width="1.3"/></svg>';

  function pintar(datos) {
    var elegida = datos.conMembresia ? 'membresia' : 'unica';
    return '' +
      '<p class="cmb__titulo">' + TEXTOS.titulo + '</p>' +
      '<div class="cmb__opciones">' +

        '<label class="cmb__opcion' + (elegida === 'unica' ? ' is-elegida' : '') + '" data-cmb-opcion="unica">' +
          '<input type="radio" name="cmb-forma" class="cmb__radio" value="unica"' + (elegida === 'unica' ? ' checked' : '') + '>' +
          '<span class="cmb__fila">' +
            '<span class="cmb__marca" aria-hidden="true"></span>' +
            '<span class="cmb__textos">' +
              '<span class="cmb__nombre">' + TEXTOS.unica + '</span>' +
              '<span class="cmb__nota">' + TEXTOS.unicaNota + '</span>' +
            '</span>' +
            '<span class="cmb__precios"><span class="cmb__precio">' + money(datos.precioUnica) + '</span></span>' +
          '</span>' +
        '</label>' +

        '<label class="cmb__opcion' + (elegida === 'membresia' ? ' is-elegida' : '') + '" data-cmb-opcion="membresia">' +
          '<input type="radio" name="cmb-forma" class="cmb__radio" value="membresia"' + (elegida === 'membresia' ? ' checked' : '') + '>' +
          '<span class="cmb__fila">' +
            '<span class="cmb__marca" aria-hidden="true"></span>' +
            '<span class="cmb__textos">' +
              '<span class="cmb__nombre">' + TEXTOS.conMembresia + '</span>' +
              '<span class="cmb__nota">+' + money(CUOTA_ANUAL) + ' al año</span>' +
            '</span>' +
            '<span class="cmb__precios">' +
              '<span class="cmb__precio">' + money(datos.precioConMembresia) + '</span>' +
              '<span class="cmb__precio-tachado">' + money(datos.precioUnica) + '</span>' +
            '</span>' +
          '</span>' +
          (datos.ahorroPedido > 0 ?
            '<span class="cmb__ahorro">' +
              '<span class="cmb__ahorro-linea">' + ICONO_CHECK + ' Ahorras <strong>' + money(datos.ahorroPedido) + '</strong> en este pedido</span>' +
              '<span class="cmb__ahorro-nota">' + TEXTOS.ahorroAnual + '</span>' +
            '</span>' : '') +
          '<span class="cmb__envio">' + ICONO_CAMION + ' ' + TEXTOS.envio + '</span>' +
        '</label>' +

      '</div>';
  }

  /* ---------- Colocación en el panel de UpCart ---------- */

  function colocar() {
    var cuerpo = document.querySelector('.upcart-cart-body');
    if (!cuerpo) return null;

    var bloque = document.getElementById(ID);
    if (!bloque) {
      bloque = document.createElement('div');
      bloque.id = ID;
      bloque.className = 'cmb';
      bloque.hidden = true;
    }

    // Va justo después de los productos. Si la app cambiara ese contenedor,
    // se queda al final del cuerpo en vez de desaparecer.
    var productos = cuerpo.querySelector('.upcart-products-section');
    var destino = productos ? productos.parentNode : cuerpo;
    var referencia = productos ? productos.nextSibling : null;
    if (bloque.parentNode !== destino || (referencia && bloque.previousSibling !== productos)) {
      destino.insertBefore(bloque, referencia);
    }
    return bloque;
  }

  /* ---------- Cambiar de opción ---------- */

  var ocupado = false;

  function elegir(opcion, bloque) {
    if (ocupado) return;
    ocupado = true;
    bloque.classList.add('is-ocupado');

    leerCarrito().then(function (carrito) {
      var datos = analizar(carrito);

      if (opcion === 'membresia' && !datos.conMembresia) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          // La membresía es una suscripción: sin `selling_plan` Shopify la
          // rechaza con un 422 («solo se puede comprar con un plan de ventas»).
          body: JSON.stringify({ id: VARIANTE, quantity: 1, selling_plan: PLAN })
        });
      }

      if (opcion === 'unica' && datos.conMembresia) {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: datos.lineaMembresia.key, quantity: 0 })
        });
      }
      return null;
    }).then(function () {
      if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
      return new Promise(function (r) { setTimeout(r, 600); });
    }).then(function () {
      return render();
    }).catch(function (e) {
      if (window.console) console.warn('[Carrito membresía] no se pudo cambiar la opción:', e);
    }).then(function () {
      ocupado = false;
      bloque.classList.remove('is-ocupado');
    });
  }

  /* ---------- Render ---------- */

  function render() {
    var bloque = colocar();
    if (!bloque) return Promise.resolve();

    if (!estaEncendido() || esMiembro()) {
      bloque.hidden = true;
      bloque.innerHTML = '';
      return Promise.resolve();
    }

    return leerCarrito().then(function (carrito) {
      var datos = analizar(carrito);
      if (!datos.hayProductos) { bloque.hidden = true; bloque.innerHTML = ''; return; }

      bloque.innerHTML = pintar(datos);
      bloque.hidden = false;

      bloque.querySelectorAll('[data-cmb-opcion]').forEach(function (label) {
        label.addEventListener('click', function (e) {
          e.preventDefault();
          elegir(label.getAttribute('data-cmb-opcion'), bloque);
        });
      });
    });
  }

  /* ---------- Arranque ---------- */

  function arrancar() {
    render();
    // Los eventos son los de la propia app: más fiable que vigilar el DOM.
    ['upcartSubscribeCartOpened', 'upcartSubscribeCartUpdated', 'upcartSubscribeCartLoaded'].forEach(function (nombre) {
      if (typeof window[nombre] === 'function') {
        try { window[nombre](function () { setTimeout(render, 120); }); } catch (e) {}
      }
    });
  }

  // La app carga por su cuenta y suele hacerlo después que este archivo, así
  // que se espera a que aparezca su API en vez de suponer un orden.
  function appLista() {
    return typeof window.upcartSubscribeCartUpdated === 'function' || !!document.querySelector('.upcart-cart-body');
  }

  if (appLista()) {
    arrancar();
  } else {
    var intentos = 0;
    var reloj = setInterval(function () {
      intentos++;
      if (appLista()) {
        clearInterval(reloj);
        arrancar();
      } else if (intentos > 60) {   // 30 s y se deja de insistir
        clearInterval(reloj);
      }
    }, 500);
  }
})();
